// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6v7PS","top":"styles_top__3sSLV","left":"styles_left__3TxKn","description":"styles_description__1_Qvb"};